export var mobilePhoneNumberReg = /^[1][3,4,5,7,8][0-9]{9}$/;
//# sourceMappingURL=mobilePhoneNumber.js.map